/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useEvents from '../../hooks/useEvents';

import EventCard from '../cards/Event';
import Title from '../typography/Title';

import styles from '../../../styles/blocks/events.module.css';

const propTypes = {
    title: PropTypes.string,
    query: PropTypes.shape({}),
    count: PropTypes.number,
    padded: PropTypes.bool,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

function EventsBlock({
    title = null,
    query = {},
    count,
    padded = false,
    className = null,
    isContainer = false,
    containerClassName = null,
}) {
    const { data: events = null, isLoading = false } = useEvents({ query, count });

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.padded]: padded,
                    [className]: className !== null,
                },
            ])}
        >
            <div
                className={classNames([
                    styles.inner,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                {title !== null ? (
                    <Title className={styles.title} size="medium" subtitle>
                        {title}
                    </Title>
                ) : null}
                <div className={styles.inner}>
                    {(events || []).map((event) => (
                        <EventCard
                            key={`event-${event?.id}`}
                            className={styles.slide}
                            item={event}
                        />
                    ))}
                    {isLoading ? <EventCard className={styles.slide} placeholder /> : null}
                    {!isLoading && (events === null || events.length === 0) ? (
                        <div className={styles.empty}>
                            <Title size="small">
                                <FormattedMessage
                                    defaultMessage="No events found, come back soon!"
                                    description="Empty label"
                                />
                            </Title>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}

EventsBlock.propTypes = propTypes;

export default EventsBlock;
